import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useUser } from "../context/userContext";
import { getPost } from "../api/axios";
const PostDetails = () => {
  const { id } = useParams();
  const access = useUser().token;
  const [post, setPost] = useState({});
  useEffect(() => {
    getPost({ id, access }).then((res) => {
      setPost(res.data.post);
    });
  }, []);

  return (
    <div>
      <div className="c">
        <navi>
          <h1>{post.name}</h1>
        </navi>
        <div className="loremimg">
          <img src={post.coverImage} alt="myprofilepic" className="mainpic" />
        </div>
        <div className="description">
          <h2 className="head">Problem That It Solves</h2>
          <p>{post.problem}</p>
        </div>
        <div className="description">
          <h2 className="head">Technologies Used</h2>
          <ul>
            {post.technologies?.map((m) => (
              <ul>{m}</ul>
            ))}
          </ul>
        </div>
        <div className="description">
          <h2 className="head">GitHub Link</h2>
          <a href="https://github.com/login">https://github.com/login</a>
        </div>
      </div>
    </div>
  );
};

export default PostDetails;
